// frontend/shared-ui/src/components/Checkbox.jsx
import React, { useEffect, useRef } from "react";

export default function Checkbox({
  checked = false,
  indeterminate = false,
  onChange,
  disabled = false,
  label,
  className = "",
  size = "md", // sm | md
  ariaLabel,
}) {
  const inputRef = useRef(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.indeterminate = !!indeterminate && !checked;
    }
  }, [indeterminate, checked]);

  const handle = (e) => {
    if (disabled) return;
    onChange?.(e.target.checked, e);
  };

  return (
    <label
      className={`fh-checkbox-control fh-checkbox-control--${size} ${disabled ? "is-disabled" : ""} ${className}`}
    >
      <input
        ref={inputRef}
        type="checkbox"
        checked={!!checked}
        onChange={handle}
        disabled={disabled}
        aria-label={ariaLabel}
      />
      <span className="fh-checkbox-control__box" aria-hidden="true">
        {indeterminate && !checked ? (
          <svg viewBox="0 0 10 10" width="10" height="10">
            <line
              x1="2"
              y1="5"
              x2="8"
              y2="5"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        ) : (
          <svg viewBox="0 0 10 10" width="10" height="10">
            <polyline
              points="2 5 4.5 7.5 8 3"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
      </span>
      {label && <span className="fh-checkbox-control__label">{label}</span>}
    </label>
  );
}
